import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { UploadMediaObjectRequest } from '@/types/requests/media-objects'
import { UploadMediaObjectResponse } from '@/types/responses/media-objects'

class MediaObjectService {
  private endpoint = `${API_PATH_INTERNAL}/media-objects`

  async uploadMediaObject(
    request: UploadMediaObjectRequest,
  ): Promise<UploadMediaObjectResponse> {
    const response = await apiService.post(this.endpoint, request, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data
  }
}

const mediaObjectService = new MediaObjectService()

export default mediaObjectService
